module.exports = __webpack_public_path__ + "img/logo-white.3b1f98a7.png";